import script from "./AminaView.vue?vue&type=script&setup=true&lang=js"
export * from "./AminaView.vue?vue&type=script&setup=true&lang=js"

import "./AminaView.vue?vue&type=style&index=0&id=5f624ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f624ff6"]])

export default __exports__